export const titleText = "You hold a qualified NFT and\nmay proceed to the Ceremony"
export const ctaOneText = "Step Inside"
